<template>
    <div class="container" v-if="document">
        <Title>{{document.title}}</Title>
        <div class="text" v-html="document.text"></div>
    </div>
</template>

<script>
    import Title from "../ui/Title";
    import {LIGHTBOX_OPEN} from "../store/actions";

    export default {
        name: "documentDetail",
        components: {Title},
        computed: {
            document() {
                return this.$store.getters.documentById(this.$route.params.id)
            }
        },

        methods: {
            refreshEventListeners() {
                const currentUrl = location.href.replace(location.pathname, '');
                
                this.$el.querySelectorAll('figure img').forEach(i => {
                    i.addEventListener('click', (ev) => {
                        ev.preventDefault();

                        this.$store.dispatch(LIGHTBOX_OPEN, {
                            type: 'image',
                            url: `${currentUrl}/${i.getAttribute('src')}`
                        });

                    })
                })

                this.$el.querySelectorAll('figure .video-lightbox').forEach(i => {
                    i.addEventListener('click', (ev) => {
                        ev.preventDefault();

                        this.$store.dispatch(LIGHTBOX_OPEN, {
                            type: 'video',
                            url: `${currentUrl}/${i.getAttribute('href')}`
                        });

                    })
                })
            }
        },

        watch: {
            document: function () {
                setTimeout(() => {
                    this.refreshEventListeners();
                }, 1)
            }
        },

        mounted: function () {
            setTimeout(() => {
                this.refreshEventListeners();
            }, 1)
        }
    };
</script>


<style lang="scss">

    .text {
        p, ul, ol {

            font-size: 1.6rem;
            line-height: 2.4rem;

            max-width: 700px;
            margin-bottom: 4rem;
        }

        ul, ol {
            margin-left: 2rem;
        }

        li {
            margin-bottom: 1rem;
        }

        .image, .video {
            max-width: 700px;
            width: 100%;
            margin-bottom: 4rem;


            cursor: pointer;

            img, video {
                border: 3px solid #efefef;

                display: block;
                max-width: 100%;
                height: auto;
            }

            figcaption {
                text-align: right;
                margin-top: 1rem;
                font-size: 1.4rem;
            }

        }

        li .image {
            margin-top: 4rem;
        }
    }
</style>